import { FC } from 'react'
import {
  Card,
  LoadMoreSection,
  Row,
  Skeleton,
  Typography,
} from '@repo/ui/components'

import { useGetReferralList } from '@repo/services'
import { InviteItem } from './invite-item'
import { InviteEmptyState } from './invite.empty-state'
import { useTranslate } from '@repo/shared/hooks'
import { cn } from '@repo/ui/lib'

export const InviteTable: FC<{
  userID?: number
  forceMobileStyle?: boolean
}> = ({ userID, forceMobileStyle = false }) => {
  const { t } = useTranslate()
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetReferralList({
      skip: 0,
      limit: 10,
      userID: userID ?? undefined,
    })
  const total = data?.pages[0]?.data?.total || 0

  const referrals =
    data?.pages?.flatMap((page) => page.data?.referrals || []) || []

  return (
    <Card
      withoutBorder
      className={cn(
        'flex flex-col',
        userID ? 'border-none !p-[unset] mt-md' : 'overflow-y-auto ',
      )}
    >
      <Row className='px-sm gap-2xs'>
        <Typography size='sm' weight='bold'>
          {userID
            ? t('clubPage_invite_invited')
            : t('clubPage_invite_invited_you')}
        </Typography>

        <Typography size='sm' color='text-neutral-surface-60'>
          {`(`}
        </Typography>
        <Typography size='sm' weight='bold' color='text-neutral-surface-100'>
          {!isLoading ? total : <Skeleton className='w-2 h-2 rounded-none' />}
        </Typography>
        <Typography size='sm' color='text-neutral-surface-60'>
          {t('clubPage_invite_subscribers_unit')}
        </Typography>
        <Typography size='sm' color='text-neutral-surface-60'>{`)`}</Typography>
      </Row>
      {referrals.map((row, idx) => (
        <InviteItem
          key={`${userID ?? ''}-${idx}-invite-item`}
          item={row}
          forceMobileStyle={forceMobileStyle}
        />
      ))}
      {referrals.length === 0 && !isLoading && (
        <InviteEmptyState userID={userID} />
      )}
      <LoadMoreSection
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
      />
    </Card>
  )
}
